import { ApolloQueryResult } from "@apollo/client";
import { addDays, format } from "date-fns";
import { useEffect, useState } from "react";
import {
    AccountSubscriptionsQuery,
    useAccountSubscriptionsLazyQuery
} from "../graphql";

const PER_PAGE = 100;

function useAccountSubscriptions(
    initialFrom?: Date,
    initialTo?: Date
): {
  items: AccountSubscriptionsQuery["subscriptions"]["nodes"];
  hasNextPage?: boolean;
  loading: boolean;
  totalCount: number;
  loadMore?: () => Promise<ApolloQueryResult<AccountSubscriptionsQuery>>;
  refresh?: ({
      from,
      to,
      endFrom,
      endTo,
      tierId
  }: {
    from?: Date;
    to?: Date;
    endFrom?: Date;
    endTo?: Date;
    tierId?: number;
  }) => void;
} {
    const [query, setQuery] = useState({
        from: initialFrom,
        to: initialTo,
        endFrom: null,
        endTo: null,
        tierId: null
    });

    const { from, to, endFrom, endTo, tierId } = query;
    const variables: any = {
        page: 1,
        pageLimit: PER_PAGE,
        range:
      from && to
          ? {
              from: from ? format(addDays(from, -1), "yyyy-MM-dd") : null,
              to: to ? format(addDays(to, 1), "yyyy-MM-dd") : new Date()
          }
          : null,
        endRange:
      endFrom && endTo
          ? {
              from: endFrom ? format(addDays(endFrom, -1), "yyyy-MM-dd") : null,
              to: endTo ? format(addDays(endTo, 1), "yyyy-MM-dd") : new Date()
          }
          : null
    };

    // if (tierId) {
    variables.tierId = tierId;
    // }

    const [
        request,
        { loading, data, fetchMore }
    ] = useAccountSubscriptionsLazyQuery({
        variables,
        notifyOnNetworkStatusChange: true
    });

    useEffect(() => {
        request();
    }, [request]);

    const refresh = ({ from, to, endFrom, endTo, tierId }) => {
        debugger;
        setQuery({
            from: from || query.from,
            to: to || query.to,
            endFrom: endFrom || query.endFrom,
            endTo: endTo || query.endTo,
            tierId: tierId ? (tierId === -1 ? null : tierId) : query.tierId
        });
    };

    const loadMore = () => {
        return fetchMore({
            variables: {
                ...variables,
                page: data?.subscriptions?.pageInfo?.nextPage || 1
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                const newNodes = fetchMoreResult?.subscriptions.nodes;

                return newNodes.length
                    ? {
                        ...fetchMoreResult,
                        subscriptions: {
                            ...fetchMoreResult?.subscriptions,
                            nodes: [...previousResult?.subscriptions.nodes, ...newNodes]
                        }
                    }
                    : previousResult;
            }
        });
    };
    return {
        totalCount: data?.subscriptions?.totalCount || 0,
        items: data?.subscriptions?.nodes || [],
        hasNextPage: data?.subscriptions?.pageInfo?.hasNextPage,
        loading,
        loadMore,
        refresh
    };
}
export { useAccountSubscriptions };
